<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">DECLARACIÓN JURADA DE DOMICILIO</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label class="mr-1">Nombres:</label>
                <p>{{ persona.per_nombres }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label class="mr-1">Primer Apellido:</label>
                <p>{{ persona.per_primer_apellido }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label class="mr-1">Segundo Apellido:</label>
                <p>{{ persona.per_segundo_apellido }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label>Tipo Documento:</label>
                <p>{{ persona.tipo_documento }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-6">
                <label>Nro. Documento:</label>
                <p>{{ persona.per_numero_documento }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="row form-group">
              <div class="col-12 col-md-6">
                <label>Fecha Nacimiento:</label>
                <p>{{ formatFecha(persona.per_fecha_nacimiento) }}</p>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-6">
                <label>Nacionalidad:</label>
                <p>{{ persona.nacionalidad }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col md-12">
            <b-tabs content-class="mt-3" v-model="tabHistorial">
              <b-tab title="NUEVA DECLARACIÓN">
                <div class="row mb-4 mt-4">
                  <div class="col-12 col-md-12">
                    <div class="row form-group">
                      <div class="col-12 col-md-12">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="HOS"
                            name="tipo_domicilio"
                            id="rdHOS"
                            v-model="domicilio.tipo_domicilio"
                            @change="onChangeTipoDomicilio($event)"
                          />
                          <label class="form-check-label" for="rdHOS"
                            >Centro de Hospedaje</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="RES"
                            name="tipo_domicilio"
                            id="rdRES"
                            v-model="domicilio.tipo_domicilio"
                            @change="onChangeTipoDomicilio($event)"
                          />
                          <label class="form-check-label" for="rdRES"
                            >Domicilio Particular</label
                          >
                        </div>
                      </div>
                    </div>

                    <CentroHospedaje
                      :domicilio="domicilio"
                      v-show="disabledHos == 1"
                    />
                    <DomicilioParticular
                      :domicilio="domicilio"
                      v-show="disabledRes == 1"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-12 text-right">
                    <router-link
                      to="/analista/buscarPersona"
                      class="btn btn-primary mr-2"
                      ><small>Cancelar</small></router-link
                    >
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="procesarDomicilio"
                    >
                      <small>Registrar</small>
                    </button>
                  </div>
                </div>
              </b-tab>
              <b-tab title="HISTORIAL DE DECLARACIONES">
                <div class="row">
                  <div class="col-lg-12 col-md-12">
                    <div
                      v-if="
                        domicilios.length == 0    
                      "
                    >
                      <a 
                        type="button"
                        class="btn btn-danger"
                        @click="showModalDeclarado(persona)"
                        v-if="formatoFechaReg(persona.fecha_vencimiento)<=formatoFechaReg(fecha_actual)"
                      >
                        <small>Multar</small>
                      </a>
                      <div class="row form-group">
                        <div class="col-12 col-md-12">
                          <label class="mr-1"> Registro Usuario:</label>
                          <p>
                            {{ "Fecha Registro:"+persona.fecha_reg}} <br> {{"Fecha vencimiento: "+ formatoFecha(persona.fecha_vencimiento) }} <br>
                         
                          </p>
                        </div>
                      </div>
                    </div>
                   
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr class="text-center">
                          <th>#</th>
                          <th>
                            <small class="font-weight-bold text-info"
                              >HOSPEDAJE</small
                            >/<small class="font-weight-bold text-primary"
                              >VIVIENDA</small
                            >
                          </th>
                          <th>
                            <small class="font-weight-bold">DIRECCIÓN</small>
                          </th>
                          <th>
                            <small class="font-weight-bold"
                              >FECHA DECLARADA</small
                            >
                          </th>
                          <th>
                            <small class="font-weight-bold">SANCION</small>
                          </th>
                          <th>
                            <small class="font-weight-bold">ACCIONES</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in domicilios"
                          :key="index"
                          :class="{ 'text-danger': item.multa }"
                        >
                          <!--1-->
                          <td class="text-center">
                            <small>{{ index + 1 }}</small>
                          </td>
                          <!--2-->
                          <!-- <td v-if="item.tipo_domicilio =='ND'"><small>NO DECLARO DOMICILIO</small></td>                             -->
                          <!-- <td v-if="item.id_empresa == 0 && item.tipo_domicilio =='RES'"><small>{{item.domicilio}}</small></td>
                          <td v-if="item.id_empresa > 0 && item.tipo_domicilio =='HOS'"><small>{{item.emp_razon_social}}</small></td> -->
                          <td>
                            <small v-if="item.tipo_domicilio == 'ND'"
                              >NO DECLARO DOMICILIO</small
                            >
                            <small v-if="item.tipo_domicilio == 'RE'"
                              >REINGRESO</small
                            >
                            <small v-if="item.tipo_domicilio == 'NOT'"
                              >NOTIFICACIÓN DE DECLARACIÓN</small
                            >
                            <small v-else>{{ item.domicilio }}</small>
                          </td>
                          <!--3-->
                          <td>
                            <small v-if="item.tipo_domicilio == 'RES'">
                              {{ item.direccion }} <br />
                              <span class="text-muted">{{
                                item.departamento
                              }}</span>
                            </small>
                            <small v-if="item.tipo_domicilio == 'HOS'">
                              {{ item.direccion }} <br />
                              <span class="text-muted">{{
                                item.departamento + " - " + item.municipio
                              }}</span>
                            </small>
                            <small
                              v-if="
                                item.tipo_domicilio == 'HOS' &&
                                  item.empresa_persona == 1
                              "
                            >
                              {{ item.direccion }} <br />
                              <span class="text-muted">{{
                                item.departamento
                              }}</span>
                            </small>
                          </td>
                          <!--4-->
                          <td class="text-center">
                            <small
                              v-if="
                                item.tipo_domicilio != 'ND' &&
                                  item.tipo_domicilio != 'RE' &&
                                  item.tipo_domicilio != 'NOT'
                              "
                            >
                              {{ "De: " + item.fecha_inicio }} <br />
                              {{ "A: " + item.fecha_fin }} <br />
                              {{ "Fecha Registro:" + item.fecha_reg }}
                            </small>
                            <small v-else>
                              {{ "Fecha de ingreso: " + item.fecha_reg }}
                            </small>
                          </td>
                          <!--5-->
                          <td class="text-center">
                            <span
                              v-if="
                                (item.multa == true &&
                                  item.revisado == 0 &&
                                  item.pago !== true) ||
                                  (item.multa == true &&
                                    item.revisado == 3 &&
                                    item.pago !== true) ||
                                  (item.pago !== true &&
                                    item.multa == true &&
                                    item.tipo_domicilio == 'ND' &&
                                    item.revisado == 1)||
                                  (item.pago !== true &&
                                    item.multa == true &&
                                    item.tipo_domicilio == 'NOT' &&
                                    item.revisado == 1)||
                                  (item.pago !== true &&
                                    item.multa == true &&
                                    item.tipo_domicilio == 'RE' &&
                                    item.revisado == 1)
                              "
                              class="badge badge-success"
                              >HABILITADO</span
                            >
                            <span
                              v-if="
                                item.multa == false &&
                                  (item.revisado == 0 ||
                                    item.revisado == 3 ||
                                    (item.tipo_domicilio == 'ND' &&
                                      item.revisado == 1) ||
                                    (item.tipo_domicilio == 'RE' &&
                                      item.revisado == 1) ||
                                    (item.tipo_domicilio == 'NOT' &&
                                      item.revisado == 1))
                              "
                              class="badge badge-danger"
                              >NO DECLARO</span
                            >
                            <span
                              v-if="
                                (item.tipo_domicilio !== 'ND' &&
                                  item.tipo_domicilio !== 'RE' &&
                                  item.tipo_domicilio !== 'NOT' &&
                                  item.revisado == 2 &&
                                  item.observado == false) ||
                                  (item.tipo_domicilio !== 'ND' &&
                                    item.tipo_domicilio !== 'RE' &&
                                    item.tipo_domicilio !== 'NOT' &&
                                    item.revisado == 1 &&
                                    item.observado == false)
                              "
                              class="badge badge-secondary"
                              >DECLARÓ</span
                            >
                            <span
                              v-if="
                                item.pago == true ||
                                  (item.pago == true && item.observado == true)
                              "
                              class="badge badge-primary"
                              >CANCELADO</span
                            >
                            <span
                              v-if="
                                item.pago !== true && item.observado == true
                              "
                              class="badge badge-info"
                              >OBSERVADO</span
                            >
                          </td>

                          <!--6-->
                          <td class="text-center">
                            <span
                              v-if="
                                $store.state.usuarioDB.id_rol == 2 &&
                                  item.observado == false &&
                                  item.multa != true &&
                                  (item.revisado == 2 || item.revisado == 1)
                              "
                              class="btn btn-outline-warning btn-sm mr-2"
                              title="Observar"
                              @click="showModalObservados(item)"
                            >
                              <i class="fa fa-eye"></i>
                            </span>
                            <span
                              v-if="
                                item.multa !== true &&
                                  (item.revisado == 0 ||
                                    (item.tipo_domicilio == 'ND' &&
                                      item.revisado == 1) ||
                                    (item.tipo_domicilio == 'RE' &&
                                      item.revisado == 1) ||
                                    (item.tipo_domicilio == 'NOT' &&
                                      item.revisado == 1)||
                                    item.revisado == 3 ||
                                    item.observado == true)
                              "
                              class="btn btn-outline-danger btn-sm mr-2"
                              title="Sanción"
                              @click="showModal(item)"
                            >
                              <i class="fa fa-credit-card"></i>
                            </span>
                            <!--<a v-if="item.multa == true && item.revisado == 0 || item.multa == true && item.revisado == 3 || item.multa == true && item.pago !== true && item.tipo_domicilio == 'ND' && item.revisado == 1  "
                        class="btn btn-outline-primary btn-sm mr-2"
                        title="Descargar"
                        @click="obtenerTalon(item.id_persona)">
                        <i class="fa fa-file"></i>
                      </a>-->

                            <span
                              v-if="
                                (item.multa == true &&
                                  item.revisado == 0 &&
                                  item.pago !== true) ||
                                  (item.multa == true &&
                                    item.revisado == 3 &&
                                    item.pago !== true) ||
                                  (item.multa == true &&
                                    item.revisado == 1 &&
                                    item.pago !== true) ||
                                  (item.multa == true && item.pago !== true)
                              "
                              class="btn btn-outline-primary btn-sm mr-2"
                              title="Sanción"
                              @click="showModal_multa(item)"
                            >
                              <i class="fa fa-credit-card"></i>
                            </span>
                            <!-- <a v-if="item.multa !== true && item.revisado == 0 || item.multa !== true && item.revisado == 3 || item.multa == true && item.revisado == 3 && item.pago !== true|| item.multa !== true && item.revisado == 1 && item.pago !== true"
                        class="btn btn-outline-success btn-sm mr-2"
                        title="Acta de Consignacion"
                        @click="obtenerDocumento(item.id_persona)"
                        >
                        <i class="fa fa-file"></i>
                      </a>-->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      class="modal fade"
      title="SANCIÓN"
      size="xl"
      hide-footer
      ref="modalSancionDeclarado"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>
                  {{ elegido.per_nombres + " "
                  }}{{ elegido.per_primer_apellido + " "
                  }}{{ elegido.per_segundo_apellido }}
                </td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>{{ elegido.per_numero_documento }}</td>
              </tr>
              <tr>
                <th>Nacionalidad:</th>
                <td>{{ elegido.nombre }}</td>
              </tr>

              
             
            </table>
          </div>
          <div class="col-6">
            <div class="alert alert-warning">
              <h5 class="text-dark text-justify">
                Si el ciudadano no declara su dirección en un máximo de dos días
                calendario, o se verifica que su declaración no es real, es
                sujeto a sanción según art. 37 de la reglamentación de la ley
                370.
              </h5>
            </div>
            <hr />
            <div class="form-group">
              <label class=" mr-1">Observación de la sanción:</label>
              <textarea
                type="text"
                class="form form-control"
                v-model="elegido.observacion_sancion"
                @keyup="
                  elegido.observacion_sancion = elegido.observacion_sancion.toUpperCase()
                "
                placeholder="Indique motivos por los cuales se aplicará la sanción"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModalDeclarado" class="btn btn-secondary mr-4">Cerrar</a>
            <button
              @click="RegistrarSancionNoRegistrados(elegido.id_persona)"
              :disabled="elegido.observacion_sancion == undefined"
              class="btn btn-danger"
            >
              APLICAR SANCIÓN
            </button>
          </div>
        </div>
      </div>
    </b-modal>
<b-modal
      class="modal fade"
      title="SANCIÓN"
      size="xl"
      hide-footer
      ref="modalSancion"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>
                  {{ elegido.per_nombres + " "
                  }}{{ elegido.per_primer_apellido + " "
                  }}{{ elegido.per_segundo_apellido }}
                </td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>{{ elegido.per_numero_documento }}</td>
              </tr>
              <tr>
                <th>Nacionalidad:</th>
                <td>{{ elegido.nombre }}</td>
              </tr>

              <tr>
                <th>Desde:</th>
                <td>{{ elegido.fecha_inicio }}</td>
              </tr>
              <tr v-if="elegido.fecha_fin">
                <th>Hasta:</th>
                <td>{{ elegido.fecha_fin }}</td>
              </tr>
            </table>
          </div>
          <div class="col-6">
            <div class="alert alert-warning">
              <h5 class="text-dark text-justify">
                Si el ciudadano no declara su dirección en un máximo de dos días
                calendario, o se verifica que su declaración no es real, es
                sujeto a sanción según art. 37 de la reglamentación de la ley
                370.
              </h5>
            </div>
            <hr />
            <div class="form-group">
              <label class=" mr-1">Observación de la sanción:</label>
              <textarea
                type="text"
                class="form form-control"
                v-model="elegido.observacion_sancion"
                @keyup="
                  elegido.observacion_sancion = elegido.observacion_sancion.toUpperCase()
                "
                placeholder="Indique motivos por los cuales se aplicará la sanción"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModal" class="btn btn-secondary mr-4">Cerrar</a>
            <button
              @click="registrarSancion(elegido.id_persona)"
              :disabled="elegido.observacion_sancion == undefined"
              class="btn btn-danger"
            >
              APLICAR SANCIÓN
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      class="modal fade"
      title="MULTA"
      size="xl"
      hide-footer
      ref="modalMulta"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>
                  {{ elegido.per_nombres + " "
                  }}{{ elegido.per_primer_apellido + " "
                  }}{{ elegido.per_segundo_apellido }}
                </td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>{{ elegido.per_numero_documento }}</td>
              </tr>
              <tr>
                <th>Actualizacion de la UFV:</th>
                <td>
                  
                 
                </td>
              </tr>

              <tr>
                <th>Valor Multa en UFVs</th>
                <td>{{ elegido.valor_multa_ufv }}</td>
              </tr>
              <tr>
                <th>Valor Multa en Bs.:</th>
                <td>{{ elegido.valor_multa_bs }}</td>
              </tr>
            </table>
          </div>
          <div class="col-6">
            <div class="form-group">
              <!--<div class="col-6">
                <label class=" mr-1">Fecha Registro:</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="elegido.fecha_reg_deposito"
                />
              </div>-->
              <div class="col-6">
                <label class=" ">Tipo de Cobro</label>
                <select class="custom-select" v-model="elegido.tipo_deposito">
                  <option value="">SELECCIONAR</option>
                  <option value="EFECTIVO">EFECTIVO</option>
                  <option value="BOLETA ENTIDAD BANCARIA"
                    >BOLETA ENTIDAD BANCARIA</option
                  >
                  <option value="POS">POS</option>
                  <option value="COBRO ELECTRÓNICO">COBRO ELECTRÓNICO</option>
                </select>
              </div>
              <div class="col-6">
                <label class=" mr-1">Número Depósito</label>

                <input
                  type="text"
                  class="form-control"
                  placeholder="Ej. 123456789"
                  v-model="elegido.deposito"
                  @keyup="elegido.deposito = elegido.deposito.toUpperCase()"
                  :disabled="this.elegido.tipo_deposito == 'EFECTIVO'"
                />
              </div>
              <div class="col-6">
                <label class=" mr-1">Fecha de Depósito:</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="elegido.fecha_deposito"
                />
              </div>
            </div>
            <hr />
            <div class="form-group">
              <label class=" mr-1">Tipo Infracción:</label>
              {{ tipo_infraccion }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModal_multa" class="btn btn-secondary mr-4"
              >Cerrar</a
            >
            <!-- <button
              @click="registrarMulta(elegido.id_persona)"
              :disabled="elegido.fecha_deposito == undefined"
              class="btn btn-danger"
            >
              APLICAR SANCIÓN
            </button>-->
            <button
              @click="registrarDeposito(elegido)"
              :disabled="elegido.fecha_deposito == undefined"
              class="btn btn-danger"
            >
              PAGO MULTA
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      class="modal fade"
      title="OBSERVAR"
      size="xl"
      hide-footer
      ref="modalObservacion"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-6">
            <table class="table table-sm table-bordered table-condensed">
              <tr>
                <th>Nombre Completo:</th>
                <td>
                  {{ elegido.per_nombres + " "
                  }}{{ elegido.per_primer_apellido + " "
                  }}{{ elegido.per_segundo_apellido }}
                </td>
              </tr>
              <tr>
                <th>Nro. Documento:</th>
                <td>
                  {{ elegido.per_numero_documento }} <br />
                  {{ elegido.tipo_documento }}
                </td>
              </tr>
              <tr>
                <th>Nacionalidad:</th>
                <td>{{ elegido.nombre }}</td>
              </tr>
            </table>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class=" mr-1">Observación de la sanción:</label>
              <textarea
                type="text"
                class="form form-control"
                v-model="elegido.descripcion_observacion"
                @keyup="
                  elegido.descripcion_observacion = elegido.descripcion_observacion.toUpperCase()
                "
                placeholder="Indique motivos por los cuales se aplicará la sanción"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6"></div>

          <div class="col-md-6 float-right">
            <a @click="hideModalObservado" class="btn btn-secondary mr-4"
              >CANCELAR</a
            >
            <button
              @click="registrarObservacion(elegido)"
              :disabled="elegido.descripcion_observacion == undefined"
              class="btn btn-danger"
            >
              APLICAR OBSERVACIÓN
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "../../components/Loading";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

//const letras = helpers.regex("alpha", /^[a-zA-Z ]*$/);
import CentroHospedaje from "../../components/analista/CentroHospedaje";
import DomicilioParticular from "../../components/analista/DomicilioParticular";

export default {
  name: "revisarSancion",
  components: {
    Loading,
    CentroHospedaje,
    DomicilioParticular,
  },
  data() {
    return {
      fecha_deposito: new moment().format("YYYY-MM-DD"),
      fecha_reg_deposito: moment(new Date()).format("YYYY-MM-DD"),
      fecha_ufv: moment(new Date()).format("YYYY-MM-DD"),
      fecha_actual: new Date(),
      elegido: {},
      
      listado_ufv: {
       
      },
      descripcion_observacion: "",
      per_nombres: "",
      per_primer_apellido: "",
      per_segundo_apellido: "",
      per_numero_documento: "",
      nacionalidad: "",
      departamento: "",
      numero_deposito: "",
      //valor_multa_ufv:"",
      //valor_multa_bs:"",
      //fecha_deposito:"",
      codigo_siget: "",
      tipo_deposito: "",
      tipo_infraccion:
        "INCUMPLIMIENTO A LO ESTABLECIDO EN EL D.S. N° 4574 (REGISTRO SIGEMIG)",
      //fecha_reg_deposito:"",
      valor_ufv: "",
      id_persona_multa: {},
      personas_domicilio: {},
      parametro: "",
      ufv: 2.37,
      multa: true,
      pago: true,
      observado: true,
      totalpagar: 100,
      valor_multa_bs: "",
      valor_multa_ufv: 100,
      registrosMultados: [],
      registrosVencidos: [],
      registrosEncontrados: [],
      //tipo_deposito: "",
      deposito: "",
      urlt: process.env.VUE_APP_URL + "/documentoTalonControl/",
      url_ac: process.env.VUE_APP_URL + "/documentoConsignacion/",
      persona: {
        id_persona: 0,
        per_nombres: "",
        per_per_primer_apellido: "",
        per_per_segundo_apellido: "",
        per_fecha_nacimiento: "",
        per_email: "",
        par_tipo_documento: "",
        per_numero_documento: "",
        par_nacionalidad: "",
        tipo_persona: 3,
      },
      domicilio: {
        id_persona: 0,
        id_empresa: "",
        tipo_domicilio: "HOS",
        nombre_domicilio: "",
        direccion: "",
        telefono: "",
        fecha_inicio: null,
        fecha_fin: null,
        tipo_documento: "",
        nro_documento: "",
        departamento: "",
        empresa_persona: 0,
      },
      disabledHos: 1,
      disabledRes: 0,
      disabledND: 0,
      cargando: false,
      submitted: false,
      id: 0,
      domicilios: [],
      empresas: [],
      tabHistorial: 0,
    };
  },

  methods: {
    showModalObservados(item) {
      this.elegido = item;
      this.$refs["modalObservacion"].show();
    },
    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    showModal(item) {
      this.listaUfv();
      console.log("ufvvalor:",this.listaUfv())
      this.elegido = item;
      this.$refs["modalSancion"].show();
    },
    hideModal() {
      this.$refs["modalSancion"].hide();
    },
    showModalDeclarado(persona) {
      
      this.elegido = persona;
      this.$refs["modalSancionDeclarado"].show();
    },
    hideModalDeclarado() {
      this.$refs["modalSancionDeclarado"].hide();
    },
    showModal_multa(item) {
     
      this.elegido = item;
      this.$refs["modalMulta"].show();
    },
    hideModal_multa() {
      this.$refs["modalMulta"].hide();
    },
    async RegistrarSancionNoRegistrados() {
      let ufv_valor = this.listado_ufv.monto;
      let data = {
        id_persona: this.elegido.id_persona,
        observacion_sancion: this.elegido.observacion_sancion,
        multa: this.multa,
        valor_multa_ufv: this.valor_multa_ufv,
        valor_multa_bs: ufv_valor * this.valor_multa_ufv,
      };
 
      try {
        this.resultados = await this.axios.post(`/domicilioOperadorPersonasNoDeclarados`, data);
        this.actuaPersonas = this.resultados.data.contenido;
        this.hideModalDeclarado();
        this.$swal({
          title: "<strong>REINGRESO Registrada</strong>",
          type: "success",
          html: `El reingreso fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
        this.onLoadDomicilios(this.id);
        this.obtenerDocumento(this.id);
        //this.limpiar();
      } catch (error) {
        console.log(error);
      }
    },
        async RegistrarNotificacion() {
      let data = {
        id_persona: this.elegido.id_persona,
      };
      try {
        this.resultados = await this.axios.post(`/domicilioPersonasNotificacion`, data);
        this.PersonasNotificadas = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async registrarMulta(elegido) {
      this.id_persona_multa = elegido;
      let data = {
        id_domicilios: this.elegido.id_domicilios,
        pago: this.pago,
        
      };

      try {
        this.resultados = await this.axios.put(
          `/MultaPersonaDepositoFron`,
          data
        );
        this.registros = this.resultados.data.contenido;

        this.hideModal_multa();
        this.$swal({
          title: "<strong>REGISTRO EXITOSA</strong>",
          type: "success",
          html: `El dato fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
        //this.onLoadDomicilios(this.id);
      } catch (error) {
        console.log(error);
      }
    },
    async registrarSancion(elegido) {
      //this.listaUfv();

      let ufv_valor = this.listado_ufv.monto;
      //console.log("valor:",ufv_valor);
      if(this.ufv_valor==undefined || this.ufv_valor=='' || this.ufv_valor==0){
          ufv_valor=2.37
      }
      //console.log("estoy aqui:");
      this.id_persona_multa = elegido;
      let data = {
        id_domicilios: this.elegido.id_domicilios,
        observacion_sancion: this.elegido.observacion_sancion,
        multa: this.multa,
        valor_multa_ufv: this.valor_multa_ufv,
        valor_multa_bs: ufv_valor * this.valor_multa_ufv,
        pago:this.pago,
      };

      try {
        this.resultados = await this.axios.put(`/updateMultaPersona`, data);
        this.registros = this.resultados.data.contenido;

        this.hideModal();
        this.$swal({
          title: "<strong>REGISTRO EXITOSA</strong>",
          type: "success",
          html: `El dato fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });

        ///this.AnalisisbusquedaPersona(this.parametro);
        this.onLoadDomicilios(this.id);
        this.obtenerDocumento(this.id);
      } catch (error) {
        console.log(error);
      }
    },
    async registrarDeposito(elegido) {
      let ufv_valor = this.listado_ufv.monto;

      let data = {
        id_domicilios: this.elegido.id_domicilios,
        per_nombres: this.elegido.per_nombres,
        per_primer_apellido: this.elegido.per_primer_apellido,
        per_segundo_apellido: this.elegido.per_segundo_apellido,
        per_numero_documento: this.elegido.per_numero_documento,
        nacionalidad: this.elegido.nombre,
        departamento: this.elegido.departamento,
        numero_deposito: this.elegido.deposito,
        valor_multa_ufv: this.valor_multa_ufv,
        valor_multa_bs: ufv_valor * this.valor_multa_ufv,
        fecha_deposito: this.elegido.fecha_deposito,
        codigo_siget: this.elegido.codigo_siget,
        tipo_deposito: this.elegido.tipo_deposito,
        fecha_reg_deposito: this.fecha_reg_deposito,
        valor_ufv: this.listado_ufv.monto,
        tipo_infraccion: this.tipo_infraccion,
        //pago:this.pago,
      };

      try {
        this.resultados = await this.axios.post(`/insertarDeposito`, data);
        this.registros = this.resultados.data.contenido;

        this.hideModalObservado();
        this.$swal({
          title: "<strong>OBSERVACIÓN Registrada</strong>",
          type: "success",
          html: `la observación fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
        //this.RegistrarNotificacion()
        this.registrarMulta(elegido);
        this.obtenerTalon(this.elegido.id_domicilios);
        this.onLoadDomicilios(this.id);

        //this.obtenerDocumento(this.id);
      } catch (error) {
        console.log(error);
      }
    },
    async registrarObservacion(elegido) {
      let data = {
        id_domicilios: this.elegido.id_domicilios,
        descripcion_observacion: this.elegido.descripcion_observacion,
        per_nombres: this.elegido.per_nombres,
        per_primer_apellido: this.elegido.per_primer_apellido,
        per_segundo_apellido: this.elegido.per_segundo_apellido,
        per_numero_documento: this.elegido.per_numero_documento,
        nacionalidad: this.elegido.nombre,
        //pago:this.pago,
      };

      try {
        this.resultados = await this.axios.post(`/insertarObservacion`, data);
        this.registros = this.resultados.data.contenido;

        this.hideModalObservado();
        this.$swal({
          title: "<strong>OBSERVACIÓN Registrada</strong>",
          type: "success",
          html: `la observación fue registrada`,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonAriaLabel: "Entendido!",
        });
        this.onLoadDomicilios(this.id);
        this.registrarObservado(elegido);
      } catch (error) {
        console.log(error);
      }
    },

    async registrarObservado(elegido) {
    
      let data = {
        id_domicilios: elegido.id_domicilios,
        observado: this.observado,
      };

      try {
        this.resultados = await this.axios.put(`/actualiza_Observados`, data);
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async registrosMultadosPersona(id_persona_multa) {
      try {
        let resultados = await this.axios.get(
          `/personasMultadas/${id_persona_multa}`
        );
        this.registrosMultados = resultados.data.contenido;
        this.tituloDeclaracion = `Personas que no declararon `;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async listaUfv() {
      //let fecha = moment(this.fecha_ufv).format("YYYY-MM-DD");

      try {
        let resultados = await this.axios.get(`/lista_ufv/${this.fecha_ufv}`);
        this.listado_ufv = resultados.data.contenido;
      
        if (
          this.listado_ufv == undefined ||
          this.listado_ufv == 0 ||
          this.listado_ufv == ""
        ) {
          this.$swal({
            title: "Cargar UFVs",
            html: "Porfavor!!!!",
            type: "warning",

            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aceptar",
          });
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async registrosVencidosPersona() {
      try {
        let resultados = await this.axios.get(`/personasVencidas`);
        this.registrosVencidos = resultados.data.contenido;
        this.tituloHotel = `Personas que vencieron su declaración `;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async AnalisisbusquedaPersona(parametro) {
      try {
        if (parametro !== "") {
          let resultados = await this.axios.get(
            `/buscarPersonasMultadas/${this.parametro}`
          );
          this.registrosMultados = resultados.data.contenido;
        }
        if (parametro == "") {
          this.registrosMultados = "";
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async obtenerDocumento(item) {
      let config = { headers: { token: this.token }, responseType: "blob" };
      this.cargando = true;
      try {
        let resultados = await this.axios.get(this.url_ac + item, config);

        await this.crearDescarga(resultados, "reporte.pdf");

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async obtenerTalon(item) {
      let config = { headers: { token: this.token }, responseType: "blob" };
      this.cargando = true;
      try {
        let resultados = await this.axios.get(this.urlt + item, config);

        await this.crearDescarga(resultados, "reporte.pdf");

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    ...mapActions(["guardarUsuario"]),
    async getPersona(id) {
      try {
        let res = await this.axios.get(`/persona/${id}`);
        this.persona = res.data.contenido;
      
       /// console.log("datos:",this.persona, "fecha actual:", this.fecha_actual);
      } catch (error) {
        //this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async onLoadDomicilios(id) {
      try {
        let res = await this.axios.get(`/domicilio/${id}`);
        this.domicilios = res.data.contenido;
      } catch (error) {
        // this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async procesarDomicilio() {
      this.cargando = true;

      // Validaciones hospedaje
      if (this.disabledHos == 1) {
        this.cargando = false;
        //this.domicilio.nombre_domicilio = "";
        this.domicilio.nro_documento = "";

        if (
          this.domicilio.id_empresa == undefined ||
          this.domicilio.id_empresa == 0
        ) {
          this.$swal({
            title: "Información",
            text: "Seleccione una empresa",
            type: "info",
            confirmButtonText: "Aceptar",
          });

          return;
        }
      }

      if (this.disabledRes == 1) {
        this.cargando = false;
        this.domicilio.id_empresa = 0;
        if (
          this.domicilio.nombre_domicilio == undefined ||
          this.domicilio.nombre_domicilio == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese el nombre del hospedaje",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }

        if (
          this.domicilio.nro_documento == undefined ||
          this.domicilio.nro_documento == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese el  número de carnet del titular.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
        if (
          this.domicilio.direccion == undefined ||
          this.domicilio.direccion == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese la dirección del hospedaje.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
        if (
          this.domicilio.telefono == undefined ||
          this.domicilio.telefono == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese el teléfono del hospedaje.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
      }

      if (this.disabledND == 1) {
        this.cargando = false;
        this.extranjero.id_empresa = 0;
        this.domicilio.id_empresa = 0;
        this.domicilio.fecha_inicio = null;
        this.domicilio.fecha_fin = null;
      } else {
        this.cargando = false;
        // validacion para campos comunes para Hos, Res
        if (
          this.domicilio.departamento == undefined ||
          this.domicilio.departamento == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Seleccione Departamento.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
        if (
          this.domicilio.fecha_inicio == undefined ||
          this.domicilio.fecha_inicio == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese la fecha inicial.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
        if (
          this.domicilio.fecha_fin == undefined ||
          this.domicilio.fecha_fin == ""
        ) {
          this.$swal({
            title: "Información",
            text: "Ingrese la fecha final.",
            type: "info",
            confirmButtonText: "Aceptar",
          });
          return;
        }
      }
      //console.log('extranjero: ', this.domicilio);

      try {
        let res = await this.axios.post(`/domicilioOperador`, this.domicilio);
        if (res.status === 200) {
          this.cargando = false;
          this.$swal({
            title: "Información",
            text: "Actualización correcta de domicilio",
            type: "success",
            confirmButtonText: "Aceptar",
          });
          //carga domicilios
          this.tabHistorial = 1;
          this.onLoadDomicilios(this.id);
          //this.getPersona(this.id);
        }
      } catch (error) {
        console.log("catch: ", error);
        this.cargando = false;
      }
    },
    onChangeTipoDomicilio() {
      let opcion = this.domicilio.tipo_domicilio;
      switch (opcion) {
        case "HOS":
          this.disabledHos = 1;
          this.disabledRes = 0;
          break;
        case "RES":
          this.disabledHos = 0;
          this.disabledRes = 1;
          break;
      }
    },
    ofusca: function(cadena) {
      return window.btoa(cadena);
    },
    validaField() {
      if (this.disabledHos == 1) {
        // this.domicilio.nombre_domicilio = "";
        this.domicilio.nro_documento = "";
        if (
          this.domicilio.id_empresa == undefined ||
          this.domicilio.id_empresa == 0
        ) {
          this.valid = false;
        }
      }
      if (this.disabledRes == 1) {
        this.domicilio.id_empresa = 0;
        if (
          this.domicilio.nombre_domicilio == undefined ||
          this.domicilio.nombre_domicilio == ""
        ) {
          this.valid = false;
        }

        if (
          this.domicilio.nro_documento == undefined ||
          this.domicilio.nro_documento == ""
        ) {
          this.valid = false;
        }
      }
      return this.valid;
    },

    formatFecha(event) {
      let str = event;
      if (str != "" && str != null) {
        let arrayFecha = str.split("-");
        return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      } else {
        return "";
      }
    },
    formatoFecha(event) {
      return moment(event).format("DD/MM/YYYY HH:mm:ss");
    },
    formatoFechaReg(event) {
      return Date.parse(event);
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getDate1: function(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    async getEmpresasHospedaje() {
      try {
        let resultado = await this.axios.get(`/empresa/empresaByRubro/3`);
        this.empresas = resultado.data.contenido;
      } catch (error) {
        console.log("catch", error);
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.id = this.$route.params.id;

    this.domicilio.id_persona = this.id;
    this.getPersona(this.id);
    this.onLoadDomicilios(this.id);
    this.getEmpresasHospedaje();
   //this.listaUfv();

    //this.getTipoDocumento();
  },
  computed: {
    ...mapGetters(["estaActivo"]),
  },

  validations: {
    domicilio: {
      tipo_domicilio: { required },
    },
  },
};
</script>
